import { AxiosGet, AxiosPost } from "./AxiosCall";

export const updateViewApi = async ()=>{
    try {
      let res = await AxiosPost("view");
      return res;
    } catch (error) {
      return error;
    }
  }
  
export const getViewApi = async ()=>{
    try {
      let res = await AxiosGet("view");
      return res;
    } catch (error) {
      return error;
    }
  }